// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__Fb_wA","title":"InfoRow_title__11KDL"};